module.exports = __webpack_public_path__ + "d75e7e868aa11f6ef4453bf577c37c98.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/intro-panel-texture-320.jpg
// module id = 410
// module chunks = 0